import Icon from "@mdi/react";
import { mdiFileWordOutline, mdiFilePdfOutline, mdiFolderZipOutline, mdiFilePowerpointOutline, mdiFileOutline } from "@mdi/js";

export interface IFileLinkProps {
    url?: string;
    title?: string;
}

const FileLink = ({ url, title }: IFileLinkProps) => {
    const fileExtension = url?.split(".").pop();

    const mdiLogo = FileLinkMDILogo(fileExtension);

    return (
        <div className="mb-3">
            <a href={url} className="link-icon" target="_blank" rel="noreferrer">
                <div className="icon-round icon-round-sm mr-3">
                    <Icon path={mdiLogo} className="mdi" />
                </div>
                <span className="pt-2">{`${title} (${fileExtension})`}</span>
            </a>
        </div>
    );
};

const FileLinkMDILogo = (fileExtension?: string) => {
    if (fileExtension === "docx" || fileExtension === "doc") {
        return mdiFileWordOutline;
    } else if (fileExtension === "pdf") {
        return mdiFilePdfOutline;
    } else if (fileExtension === "rar" || fileExtension === "zip") {
        return mdiFolderZipOutline;
    } else if (fileExtension === "pptx") {
        return mdiFilePowerpointOutline;
    } else {
        return mdiFileOutline;
    }
};

export default FileLink;
